import { ReactNode } from 'react';
import {
  FormControlLabel as MuiFormControlLabel,
  FormControlLabelProps as MuiFormControlLabelProps,
} from '@mui/material';

type FormControlLabelProps = {
  children?: ReactNode;
  srcImage?: string;
} & MuiFormControlLabelProps;

export const FormControlLabel = ({ children, ...otherProps }: FormControlLabelProps) => {
  return <MuiFormControlLabel {...otherProps}>{children}</MuiFormControlLabel>;
};
